<template>
  <span style="margin:0 12px">
    <a-button @click="modalVisible=true">上传数据</a-button>
    <a-modal :visible="modalVisible" :maskClosable="false" @cancel="handleCancel">
      <div slot="title">
        上传数据
        <a-button type="link" href="/data/UX体验管理数据模板.xlsx"><a-icon type="paper-clip" />下载数据模板</a-button>
      </div>
      <a-upload name="file" :file-list="fileList" :before-upload="beforeUpload" :multiple="false" :remove="handleRemove" accept=".xlsx,.xls,.csv">
        <a-button> <a-icon type="upload" />点击选择文件</a-button>
      </a-upload>

      <template slot="footer">
        <a-button type="primary" @click="handleUpload" :disabled="fileList.length === 0">确定上传</a-button>
      </template>
    </a-modal>

  </span>
</template>

<script>
export default {
  name: 'UxUpload',
  props: [],
  data() {
    return {
      fileList: [],
      modalVisible: false,
    }
  },
  methods: {
    beforeUpload(file) {
      if(file.type == 'text/csv' || file.name.endsWith('csv') || file.name.endsWith('xlsx') || file.name.endsWith('xls')) {
        this.fileList = [file];
      }
      else {
        this.$message.error('仅支持上传csv/xlsx/xls格式文件');
      }
      return false;
    },
    handleRemove() {
      this.fileList = []
    },
    handleUpload() {
      const { fileList } = this;
      if(this.fileList.length==0) {
          this.$message.error('请选择文件')
          return
      }
      const formData = new FormData();
      if(fileList.length > 0) {
          formData.append('file', fileList[0]);
      }
      this.$service.uploadData(`${this.$service.api.project.query_fixed_module}experience_overview_upload/`, formData).then(d => {
        this.$message.success('上传成功');

        this.modalVisible = false;
        this.$emit('refresh');
        this.fileList = [];
      }).catch(error => {
        this.$message.error(`上传失败：${error&&error.detail?error.detail:'请重试'}`);
      })
    },
    handleCancel() {
      this.modalVisible = false;
    }
  }
}
</script>

<style>

</style>